import React, { Suspense, lazy } from 'react';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '../../../utils/webpack/chunkRetry';
const CommentReduxModule = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "comment_redux2" */ './CommentReduxModule')));
export const LoadableCommentReduxModule = ()=>{
    const isMounted = useIsMounted();
    if (!isMounted) {
        return null;
    }
    // prevent inside iframes
    if (typeof window !== 'undefined' && window.top !== window.self) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "LoadableCommentReduxModule"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: null
    }, /*#__PURE__*/ React.createElement(CommentReduxModule, null)));
};
LoadableCommentReduxModule.displayName = 'LoadableCommentReduxModule';
export default LoadableCommentReduxModule;
